import { Container, Fade, Modal as MuiModal, Card, Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";

interface IProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactElement;
  size: "sm" | "md" | "lg";
}

export default function Modal({ open, onClose, children, size }: IProps) {
  return (
    <MuiModal open={open} onClose={onClose} sx={{ display: "grid", placeItems: "center" }}>
      <Fade in={open}>
        <Container maxWidth={size}>
          <Card
            sx={{
              p: 4,
              backgroundImage: "url(./assets/background.svg)",
              bgcolor: "#fff",
              backgroundPosition: "center",
              backgroundSize: "cover",
              position: "relative",
            }}
          >
            <Box sx={{ position: "absolute", right: "6px", top: "6px" }}>
              <IconButton onClick={onClose}>
                <Icon icon="material-symbols:close" />
              </IconButton>
            </Box>

            {children}
          </Card>
        </Container>
      </Fade>
    </MuiModal>
  );
}
